export enum RoleTarget {
  Administrators = 0,
  Entities = 1,
}
